/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const FrenchFlagIconSvg = () => (
  <svg
    width="1.1em"
    height="1.1em"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3 2">
    <path fill="#EC1920" d="M0 0h3v2H0z"/>
    <path fill="#fff" d="M0 0h2v2H0z"/>
    <path fill="#051440" d="M0 0h1v2H0z"/>
  </svg>

);

export const FrenchFlagIcon = (props) => (
  <Icon component={FrenchFlagIconSvg} {...props} />
);
